import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    /**
     * Disable caching of GET request for IE11
     * Recommended reading: https://support.microsoft.com/en-us/help/234067/how-to-prevent-caching-in-internet-explorer
     */
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.method === 'GET') {
            const customHeaders = request.headers.append('Cache-Control', 'no-cache');

            const customRequest = request.clone({
                headers: customHeaders,
            });
            return next.handle(customRequest);
        }

        return next.handle(request);
    }
}

export const cacheInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: CacheInterceptor,
    multi: true,
};
